import React, { useEffect } from "react";
import "./index.m.css";
import { SUBSCRIBE_PAGE_TEXT } from "../../../../constants";
import { RenewalTopIcon, RenewalCheckIcon } from "./icons";

import { getAuthStatus, cleanDataLayerPayload } from "../../../helper/datalayer-utils";

export const RenewalModal = ({ onClose }) => {
  const pushToDataLayer = (eventName) => {
    if (typeof window !== "undefined") {
      const { uuid, status } = getAuthStatus();
      const eventPayload = {
        event: eventName
      };

      if (status === "logged_in" && uuid && uuid !== "NA") {
        eventPayload.uuid = uuid;
      }
      
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(cleanDataLayerPayload ? cleanDataLayerPayload(eventPayload) : eventPayload);
    }
  };

  const handleAccept = () => {
    pushToDataLayer("accept_popup");
    if (typeof window !== "undefined" && window.location.pathname !== "/subscribe") {
      window.location.href = "/subscribe";
    } else {
      onClose();
    }
  };

  const handleDismiss = () => {
    pushToDataLayer("dismiss_popup");
    onClose();
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    pushToDataLayer("renewal_prompt_impression");
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <div styleName="overlay" onClick={handleDismiss}>
      <div styleName="popupContainer" onClick={(e) => e.stopPropagation()}>
        <RenewalTopIcon />
        
        <h2 styleName="title">{SUBSCRIBE_PAGE_TEXT.RENEWAL_POPUP_TITLE}</h2>
        <p styleName="subtitle">{SUBSCRIBE_PAGE_TEXT.RENEWAL_POPUP_SUBTITLE}</p>
        
        <ul styleName="pointsList">
          {SUBSCRIBE_PAGE_TEXT.RENEWAL_POPUP_POINTS.map((point, index) => (
            <li key={index} styleName="pointItem">
              <RenewalCheckIcon />
              {point}
            </li>
          ))}
        </ul>

        <div styleName="buttonsContainer">
          <button styleName="primaryButton" onClick={handleAccept}>
            {SUBSCRIBE_PAGE_TEXT.RENEWAL_POPUP_BTN_PRIMARY}
          </button>
          <button styleName="secondaryButton" onClick={handleDismiss}>
            {SUBSCRIBE_PAGE_TEXT.RENEWAL_POPUP_BTN_SECONDARY}
          </button>
        </div>
      </div>
    </div>
  );
};
